var getFromBetween = {
    results:[],
    string:"",
    getFromBetween:function (sub1,sub2) {
        if(this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
        var SP = this.string.indexOf(sub1)+sub1.length;
        var string1 = this.string.substr(0,SP);
        var string2 = this.string.substr(SP);
        var TP = string1.length + string2.indexOf(sub2);
        return this.string.substring(SP,TP);
    },
    removeFromBetween:function (sub1,sub2) {
        if(this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
        var removal = sub1+this.getFromBetween(sub1,sub2)+sub2;
        this.string = this.string.replace(removal,"");
    },
    getAllResults:function (sub1,sub2) {
        // first check to see if we do have both substrings
        if(this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return;

        // find one result
        var result = this.getFromBetween(sub1,sub2);
        // push it to the results array
        this.results.push(result);
        console.log(result)
        // remove the most recently found one from the string
        this.removeFromBetween(sub1,sub2);

        // if there's more substrings
        if(this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
            this.getAllResults(sub1,sub2);
        }
        else return;
    },
    get:function (string,sub1,sub2) {
        this.results = [];
        this.string = string;
        this.getAllResults(sub1,sub2);
        return this.results;
    }
}

function _replaceString (marker, key, value, originalString) {
    const replaceString = `${marker}${key}${marker}`
    let re = new RegExp(replaceString, "g")
    let newString = originalString.replace(re, value)
    return newString
}

function replaceAll (string, vals) {
    console.log(`string = ${string}`)
    console.log(this.vals)
    for (let i=0; i< (Object.keys(vals)).length; i++) {
        string = _replaceString('%%', Object.keys(vals)[i], vals[Object.keys(vals)[i]], string)
        console.log('***', Object.keys(vals)[i], vals[Object.keys(vals)[i]], string)
    }
    return string
}

function getUniqueFromBetween (str, first, last) {
    return [...new Set(getFromBetween.get(str, first, last))]
}

const pipeUtils = {
    getFromBetween,
    getUniqueFromBetween,
    replaceAll
}

export default pipeUtils